<template>
  <div>
    <div v-for="(layout, i) in layouts" :key="i">
      <el-row v-if="isExpectedLayout(layout.sizeValue)">
        <el-col id="layout" :md="layout.md" :sm="layout.sm" :xs="layout.xs">
          <slot />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";

export default {
  props: {
    size: {
      type: String,
      default: "v100",
    },
  },
  data() {
    return {
      availableLayouts: {
        v100: layoutUtils.v100,
        o5v90: layoutUtils.o5v90,
        o10v80: layoutUtils.o10v80,
        o15v70: layoutUtils.o15v70,
        o20v60: layoutUtils.o20v60,
        o25v50: layoutUtils.o25v50,
      },
    };
  },
  computed: {
    layouts() {
      return [this.availableLayouts[this.size]];
    },
  },
  methods: {
    isExpectedLayout(value) {
      return this.size === value;
    },
  },
};
</script>
